/*
	Feature details are Sherlock programmable features designated to categorise properties. 
*/

Feature_details = {
	// Find check inputs for the feature details UI
	p_input_element : {}
	,
	// Find hidden element which tracks the active feature details. Holds comma delimited list of FD titles.
	p_tracking_element : {}
	,
	init : function()
	{
		// Set properties.
		Feature_details.p_input_element = jQuery('.property-search .oc-feature-detail'); //jQuery('.property-search .feature-details .form-check-input');
		Feature_details.p_tracking_element = jQuery('input[name="feature_details_include"]');
		
		// Setup UI.
		Feature_details.setup_ui();
	}
	,
	set_all_ui : function()
	{
		// Update the feature UI elements.
		Feature_details.p_input_element.each(function(pm_index){
			// Get parent element to reflect checked state via class.
			var parent_element = jQuery(this).closest('.form-check');
			if( jQuery(this).is(':checked') )
			{
				parent_element.addClass('checked');
			}
			else
			{
				parent_element.removeClass('checked');
			}
		});
		
		// Update the tracking form element.
		Feature_details.update_tracking();
		
		// Emit event. After Property Search submit.
		///var options = {};
		///jQuery(document).trigger('oc_property_sort_submit_before',options);
	}
	,
	update_tracking : function()
	{
		// Empty tracking list.
		Feature_details.p_tracking_element.val('');
		
		// Iterate through check elements and add checked values to tracking list. 
		var feature_details = '';
		Feature_details.p_input_element.each(function(pm_index){
			var sep = (feature_details == '') ? '' : ',';
			if( jQuery(this).is(':checked') )
			{
				feature_details += sep + jQuery(this).val();
			}
		});
		
		// Fill tracking list with new value.
		Feature_details.p_tracking_element.val(feature_details);
	}
	,
	setup_ui : function()
	{
		// Set check elements to trigger events on change.
		Feature_details.p_input_element.change(function(){
			
			// Set parent element to reflect checked state via class.
		    var parent_element = jQuery(this).closest('.form-check');
		    if( jQuery(this).is(':checked') )
		    {
			    parent_element.addClass('checked');
			}
			else
			{
				parent_element.removeClass('checked');
		    }
		    
		    // Reset tracking list upon check element update.
		    var options = {};
			Feature_details.p_tracking_element.trigger('sh_property_search_feature_detail_update',options);
		    
	    });
	    
	    // Set tracking element to react to check elements updates.
	    // Tracking element holds comma delimited list of FD titles.
	    Feature_details.p_tracking_element.on('sh_property_search_feature_detail_update',function(event,pm_options){
			console.log('UPDATE FEATURE DETAILS:',pm_options);
			// Empty tracking list.
			jQuery(this).val('');
			
			// Iterate through check elements and add checked values to tracking list. 
			var feature_details = '';
			Feature_details.p_input_element.each(function(pm_index){
				var sep = (feature_details == '') ? '' : ',';
				if( jQuery(this).is(':checked') )
				{
					feature_details += sep + jQuery(this).val();
				}
			});
			
			// Fill tracking list with new value.
			jQuery(this).val(feature_details);
			
	    });
	}
}


jQuery(document).ready(function(jQuery){
	
	//Feature details are Sherlock programmable features designated to categorise properties.
	Feature_details.init();

});